import { WarningTriangleIcon } from '@cfs-fixings/shared'
import classNames from 'classnames'
import { PropsWithChildren } from 'react'

type PanelSectionProps = {
  title?: string
  error?: boolean
} & PropsWithChildren

const PanelSection = ({ children, title, error = false }: PanelSectionProps) => {
  return (
    <div className="px-3.5 py-3">
      {
        title
        && (
          <h2
            className={classNames(
              'font-semibold flex text-xs leading-[14.4px] mb-[10px]',
              {
                'text-error-800': error,
                'text-gray-900': !error,
              },
            )}
          >
            {title}
            {
              error && <WarningTriangleIcon className="h-[16px] w-[16px] text-error-500 ml-[5px]" />
            }
          </h2>
        )
      }

      {children}
    </div>
  )
}

export default PanelSection
